///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/apps/administration/models/Medius.Validation.ValidatorConfiguration/Editor"/>
import DataDefinitionEditor = require("Core/Medius.Core.Web/Scripts/Medius/apps/administration/models/Medius.Data.DataDefinition/Editor");

export = function(entityWithContext:any, companyContextId:number, tabModel:any) {
    return DataDefinitionEditor(entityWithContext, companyContextId, tabModel, ["IsReadOnly"]);
};